import React from "react"
import { useContext } from "react"
import { Fragment } from "react"
import { HelpCenterContext } from "./Context/HelpCenterContext"
export const VideoArticleBlocks = ({ data }) => {
    const { dispatch } = useContext(HelpCenterContext)
    return (
        <Fragment>
            {data.sort((a, b) => a.order - b.order).map(item => (
                <div className="card hc-card" onClick={() => dispatch({ type: "TOGGLE_DETAIL_COMPONENT", payload: item })}>
                    <div className="row">
                        <div className="col-3">
                            {item.tag === "Video" && <div className="card-img hc-video"></div>}
                            {item.tag === "Article" && <div className="card-img hc-article"></div>}
                        </div>
                        <div className="col-9">
                            <div className="card-body pt-2 ps-0">
                                <strong className="topic-links">{item.text}</strong>
                                <small className="card-text text-muted d-block">{item.keyword} - <span>{item.tag}</span></small>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Fragment>
    )
}